import axios from "axios";
export const state = {
  current: {},
  save_status: false,
  systemSettings: [],
};
export const getters = {
  CurrentSettings: (state) => state.current,
  SaveStatus: (state) => state.save_status,
  getSystemSettings: (state) => state.systemSettings.data,
};

export const mutations = {
  SET_CURRENT(state, newValue) {
    state.current = newValue;
  },
  SET_SYSTEMES_SETTINGS(state, newValue) {
    state.systemSettings = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
};

export const actions = {
  changeCurrent({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`current_settings`, payload)
      .then(() => {
        dispatch("fetchCurrentSettings");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  submitSetting({ commit }, payload) {
    axios.post("systems_settings", payload).then((pos) => {
      commit("SET_SYSTEMES_SETTINGS", pos.data);
    });
  },

  fetchCurrentSettings({ commit }) {
    axios.get(`current_settings`).then((pos) => {
      commit("SET_CURRENT", pos.data);
    });
  },
  fetchSystemSettings({ commit }) {
    axios.get(`systems_settings`).then((pos) => {
      commit("SET_SYSTEMES_SETTINGS", pos.data);
    });
  },
};
